
export default{
    mixins:[],
    computed:{
       addWalletFlow(){
            if(window.ADD_WALLET_FLOW==undefined){return 'wallet'}
            else{return window.ADD_WALLET_FLOW}
        },
        promptForAccount(){
            
            if(window.ADD_WALLET_PROMPT_FOR_ACCOUNT==undefined){return false}
            else{return window.ADD_WALLET_PROMPT_FOR_ACCOUNT}
        }
    },
    data(){
        return{
             walletFlow_wallet:'wallet',
            walletFlow_walletaccount:'walletaccount',
            walletFlow_ask:'ask',
            walletFlow_role:'role'
        }
    },
    methods:{
        isRoleThatGetsAccount(role){
            //if it isn't role based, the answer is yes!
            if(this.addWalletFlow!=this.walletFlow_role){return true}
            var roles=window.ADD_WALLET_ROLES_THAT_GET_ACCOUNT
            if(roles.includes(role)){return true}
            else{return false}
        },
        isRoleThatDoesNOTRequireID(role){
         
            var roles=window.NO_REQUIRE_ID_ROLE_LIST
            if(role==undefined){return false}
            if(roles.includes(role)){return true}
            else{return false}
        }
    }

}